import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";
import { BBox } from "geojson";

type MapViewportOptions = {
  padding?: number;
  map?: google.maps.Map;
};

export function useMapViewport({ padding = 0, map }: MapViewportOptions = {}) {
  const [bbox, setBbox] = useState<BBox>([-180, -90, 180, 90]);
  const [zoom, setZoom] = useState(0);

  // observe the map to get current bounds
  useEffect(() => {
    if (!map) return;

    const listener = map.addListener("bounds_changed", () => {
      const bounds = map.getBounds();
      const zoom = map.getZoom();
      const projection = map.getProjection();

      if (!bounds || !zoom || !projection) return;

      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();

      const n = Math.min(90, ne.lat());
      const s = Math.max(-90, sw.lat());

      const w = sw.lng();
      const e = ne.lng();

      setBbox([w, s, e, n]);
      setZoom(zoom);
    });

    return () => listener.remove();
  }, [map, padding]);

  return { bbox, zoom };
}

export function degreesPerPixel(zoomLevel: number) {
  // 360° divided by the number of pixels at the zoom-level
  return 360 / (Math.pow(2, zoomLevel) * 256);
}
